import {SvgIconData} from '@shared_web/components/core/svg_icon';

export const icon_building_2_fill: SvgIconData = {
  viewBox: '1 1.2692867901018274 22 19.730713209898173',
  element: (
    <path d="M12 19H14V6.00003L20.3939 8.74028C20.7616 8.89786 21 9.2594 21 9.65943V19H23V21H1V19H3V5.6499C3 5.25472 3.23273 4.89659 3.59386 4.73609L11.2969 1.31251C11.5493 1.20035 11.8448 1.314 11.9569 1.56634C11.9853 1.63027 12 1.69945 12 1.76941V19Z" />
  ),
};
